module.exports = __webpack_public_path__ + "media/2min-video.d3262603.mp4";